import React from 'react';

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">ABOUT DÏTRIS</h1>
      
      <div className="space-y-8 text-gray-700 leading-relaxed">
        <div>
          <h2 className="text-xl font-medium mb-4 text-black">Our Story</h2>
          <p className="mb-4">
            Founded with a passion for authentic streetwear, Dïtris represents the intersection of contemporary style and timeless design. We believe in creating pieces that transcend trends and become staples in your wardrobe.
          </p>
          <p>
            Every collection is crafted with attention to detail, quality materials, and a commitment to sustainability. From our signature tees to premium outerwear, each piece tells a story of craftsmanship and authenticity.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-4 text-black">Our Philosophy</h2>
          <p className="mb-4">
            We design for those who appreciate quality over quantity. Our approach is simple: create versatile, durable pieces that fit seamlessly into your lifestyle. Whether you're exploring the city or relaxing at home, Dïtris clothing moves with you.
          </p>
          <p>
            Streetwear culture is about self-expression, community, and authenticity. We're here to support that culture by providing apparel that speaks to individuality while maintaining the highest standards of quality.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-4 text-black">Quality & Craftsmanship</h2>
          <p className="mb-4">
            We work with premium materials sourced from trusted suppliers around the world. Every garment undergoes rigorous quality control to ensure it meets our exacting standards.
          </p>
          <p>
            From the initial sketch to the final stitch, we're involved in every step of the process. This hands-on approach allows us to maintain the quality and integrity that defines the Dïtris brand.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-4 text-black">Sustainability</h2>
          <p>
            We're committed to reducing our environmental impact. This means using sustainable materials when possible, minimizing waste in our production process, and creating timeless pieces that won't end up in landfills after one season.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;